angular
    .module("App")
    .directive("caracteristiqueTerritoire", function factory() {
        var directiveDefinitionObject = {
            templateUrl:
                "js/directives/caracteristiqueTerritoireDirective.html",
            scope: {
                dataTerritoire: "=data",
                year: "=year",
            },
        };
        return directiveDefinitionObject;
    })
    .directive("localisation", function factory() {
        var directiveDefinitionObject = {
            templateUrl: "js/directives/localisationDirective.html",
            scope: {
                dataTerritoire: "=data",
            },
        };
        return directiveDefinitionObject;
    })
    .directive("patrimoineHlmGraph", [
        "$timeout",
        function factory($timeout) {
            var directiveDefinitionObject = {
                templateUrl: "js/directives/patrimoineHlmGraphDirective.html",
                scope: {
                    dataTerritoire: "=data",
                    color: "=",
                },
                link: function postLink(scope) {
                    function componentToHex(c) {
                        var hex = c.toString(16);
                        return hex.length == 1 ? "0" + hex : hex;
                    }

                    function rgbToHex(r, g, b) {
                        return (
                            "#" +
                            componentToHex(r) +
                            componentToHex(g) +
                            componentToHex(b)
                        );
                    }

                    let colorDE,
                        colorAT,
                        colorPA,
                        colorON,
                        color1,
                        color2,
                        color3,
                        color4,
                        color5,
                        color6;

                    switch (scope.color) {
                        case "blue":
                            colorDE = rgbToHex(217, 225, 240);
                            colorAT = rgbToHex(189, 215, 238);
                            colorPA = rgbToHex(155, 194, 230);
                            colorON = rgbToHex(73, 118, 199);

                            color1 = "#0000cc";
                            color2 = "#0000ff";
                            color3 = "#3232ff";
                            color4 = "#4c4cff";
                            color5 = "#6666ff";
                            color6 = "#7f7fff";
                            break;
                        case "green":
                            colorDE = rgbToHex(198, 224, 180);
                            colorAT = rgbToHex(169, 208, 142);
                            colorPA = rgbToHex(112, 173, 71);
                            colorON = rgbToHex(84, 130, 53);

                            color1 = "#004c00";
                            color2 = "#006600";
                            color3 = "#007f00";
                            color4 = "#009900";
                            color5 = "#00b200";
                            color6 = "#00cc00";
                            break;
                    }

                    scope.$on("redrawGraph", function (
                        event,
                        color,
                        data,
                        other
                    ) {
                        if (color == scope.color) redraw(data, other);
                    });

                    function redraw(data, other) {
                        scope.repartitionPatrimoine = {};
                        scope.repartitionPatrimoine.type = "PieChart";
                        scope.repartitionPatrimoine.data = {
                            cols: [
                                { id: "t", label: "Topping", type: "string" },
                                { id: "s", label: "Slices", type: "number" },
                            ],
                            rows: [
                                {
                                    c: [
                                        { v: "Avant 1960" },
                                        {
                                            v: Number(
                                                data.repartitionPatrimoine
                                                    .lgtAvant1960.PA
                                            ),
                                        },
                                    ],
                                },
                                {
                                    c: [
                                        { v: "1960-1969" },
                                        {
                                            v: Number(
                                                data.repartitionPatrimoine
                                                    .lgt60A69.PA
                                            ),
                                        },
                                    ],
                                },
                                {
                                    c: [
                                        { v: "1970-1979" },
                                        {
                                            v: Number(
                                                data.repartitionPatrimoine
                                                    .lgt70A79.PA
                                            ),
                                        },
                                    ],
                                },
                                {
                                    c: [
                                        { v: "1980-1989" },
                                        {
                                            v: Number(
                                                data.repartitionPatrimoine
                                                    .lgt80A89.PA
                                            ),
                                        },
                                    ],
                                },
                                {
                                    c: [
                                        { v: "1990-1999" },
                                        {
                                            v: Number(
                                                data.repartitionPatrimoine
                                                    .lgt90A99.PA
                                            ),
                                        },
                                    ],
                                },
                                {
                                    c: [
                                        { v: "Après 2000" },
                                        {
                                            v: Number(
                                                data.repartitionPatrimoine
                                                    .lgt2000.PA
                                            ),
                                        },
                                    ],
                                },
                            ],
                        };
                        scope.repartitionPatrimoine.options = {
                            title: "Répartition du patrimoine/an",
                            legend: { position: "right" },
                            colors: [
                                color1,
                                color2,
                                color3,
                                color4,
                                color5,
                                color6,
                            ],
                        };

                        scope.repartitionTypologie = {
                            type: "BarChart",
                            displayed: false,
                            data: {
                                cols: [
                                    {
                                        id: "month",
                                        label: "Month",
                                        type: "string",
                                        p: {},
                                    },
                                    {
                                        id: "laptop-id",
                                        label: "Demande",
                                        type: "number",
                                        p: {},
                                    },
                                    {
                                        id: "desktop-id",
                                        label: "Attribution",
                                        type: "number",
                                        p: {},
                                    },
                                    {
                                        id: "server-id",
                                        label: "Patrimoine",
                                        type: "number",
                                        p: {},
                                    },
                                    {
                                        id: "cost-id",
                                        label: "Offre Nouvelle",
                                        type: "number",
                                    },
                                ],
                                rows: [
                                    {
                                        c: [
                                            {
                                                v: "T1+2",
                                            },
                                            {
                                                v:
                                                    scope.color === "blue"
                                                        ? data
                                                              .caracteristiqueHlm
                                                              .T1T2.DE
                                                        : other
                                                              .caracteristiqueHlm
                                                              .T1T2.DE,
                                                f:
                                                    Math.round(
                                                        (scope.color === "blue"
                                                            ? data
                                                                  .caracteristiqueHlm
                                                                  .T1T2.DE
                                                            : other
                                                                  .caracteristiqueHlm
                                                                  .T1T2.DE) *
                                                            10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v:
                                                    data.caracteristiqueHlm.T1T2
                                                        .AT,
                                                f:
                                                    Math.round(
                                                        data.caracteristiqueHlm
                                                            .T1T2.AT * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v:
                                                    data.caracteristiqueHlm.T1T2
                                                        .PA,
                                                f:
                                                    Math.round(
                                                        data.caracteristiqueHlm
                                                            .T1T2.PA * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v:
                                                    data.caracteristiqueHlm.T1T2
                                                        .ON,
                                                f:
                                                    Math.round(
                                                        data.caracteristiqueHlm
                                                            .T1T2.ON * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                        ],
                                    },
                                    {
                                        c: [
                                            {
                                                v: "T3",
                                            },
                                            {
                                                v:
                                                    scope.color === "blue"
                                                        ? data
                                                              .caracteristiqueHlm
                                                              .T3.DE
                                                        : other
                                                              .caracteristiqueHlm
                                                              .T3.DE,
                                                f:
                                                    Math.round(
                                                        (scope.color === "blue"
                                                            ? data
                                                                  .caracteristiqueHlm
                                                                  .T3.DE
                                                            : other
                                                                  .caracteristiqueHlm
                                                                  .T3.DE) *
                                                            10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v:
                                                    data.caracteristiqueHlm.T3
                                                        .AT,
                                                f:
                                                    Math.round(
                                                        data.caracteristiqueHlm
                                                            .T3.AT * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v:
                                                    data.caracteristiqueHlm.T3
                                                        .PA,
                                                f:
                                                    Math.round(
                                                        data.caracteristiqueHlm
                                                            .T3.PA * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v:
                                                    data.caracteristiqueHlm.T3
                                                        .ON,
                                                f:
                                                    Math.round(
                                                        data.caracteristiqueHlm
                                                            .T3.ON * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                        ],
                                    },
                                    {
                                        c: [
                                            {
                                                v: "T4+T5",
                                            },
                                            {
                                                v:
                                                    scope.color === "blue"
                                                        ? data
                                                              .caracteristiqueHlm
                                                              .T4T5Plus.DE
                                                        : other
                                                              .caracteristiqueHlm
                                                              .T4T5Plus.DE,
                                                f:
                                                    Math.round(
                                                        (scope.color === "blue"
                                                            ? data
                                                                  .caracteristiqueHlm
                                                                  .T4T5Plus.DE
                                                            : other
                                                                  .caracteristiqueHlm
                                                                  .T4T5Plus
                                                                  .DE) * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v:
                                                    data.caracteristiqueHlm
                                                        .T4T5Plus.AT,
                                                f:
                                                    Math.round(
                                                        data.caracteristiqueHlm
                                                            .T4T5Plus.AT * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v:
                                                    data.caracteristiqueHlm
                                                        .T4T5Plus.PA,
                                                f:
                                                    Math.round(
                                                        data.caracteristiqueHlm
                                                            .T4T5Plus.PA * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v:
                                                    data.caracteristiqueHlm
                                                        .T4T5Plus.ON,
                                                f:
                                                    Math.round(
                                                        data.caracteristiqueHlm
                                                            .T4T5Plus.ON * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                        ],
                                    },
                                ],
                            },
                            options: {
                                title: "Répartition par typologie",
                                isStacked: "false",
                                fill: 20,
                                displayExactValues: true,
                                legend: { position: "top", maxLines: 3 },
                                hAxis: {
                                    format: "#%",
                                    baseline: 0,
                                },
                                colors: [
                                    scope.color === "blue"
                                        ? colorDE
                                        : rgbToHex(217, 225, 240),
                                    colorAT,
                                    colorPA,
                                    colorON,
                                ],
                            },
                            formatters: {},
                        };

                        scope.logements = {
                            type: "BarChart",
                            displayed: false,
                            data: {
                                cols: [
                                    {
                                        id: "month",
                                        label: "Month",
                                        type: "string",
                                        p: {},
                                    },
                                    {
                                        id: "laptop-id",
                                        label: "Attributions",
                                        type: "number",
                                        p: {},
                                    },
                                    {
                                        id: "laptop-id2",
                                        label: "Patrimoine",
                                        type: "number",
                                        p: {},
                                    },
                                    {
                                        id: "laptop-id2",
                                        label: "Offre nouvelle",
                                        type: "number",
                                        p: {},
                                    },
                                ],
                                rows: [
                                    {
                                        c: [
                                            {
                                                v: "",
                                            },
                                            {
                                                v: Number(
                                                    data.loyersLogementPLUSPLAI
                                                        .loyerPratiqueInf55HorsQPV
                                                        .AT
                                                ),
                                                f:
                                                    Math.round(
                                                        data
                                                            .loyersLogementPLUSPLAI
                                                            .loyerPratiqueInf55HorsQPV
                                                            .AT * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v: Number(
                                                    data.loyersLogementPLUSPLAI
                                                        .loyerPratiqueInf55HorsQPV
                                                        .PA
                                                ),
                                                f:
                                                    Math.round(
                                                        data
                                                            .loyersLogementPLUSPLAI
                                                            .loyerPratiqueInf55HorsQPV
                                                            .PA * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                            {
                                                v: Number(
                                                    data.loyersLogementPLUSPLAI
                                                        .loyerPratiqueInf55HorsQPV
                                                        .ON
                                                ),
                                                f:
                                                    Math.round(
                                                        data
                                                            .loyersLogementPLUSPLAI
                                                            .loyerPratiqueInf55HorsQPV
                                                            .ON * 10000
                                                    ) /
                                                        100 +
                                                    "%",
                                            },
                                        ],
                                    },
                                ],
                            },
                            options: {
                                title: "% logements < 5,5€/m² hors QPV",
                                isStacked: "false",
                                fill: 20,
                                legend: { position: "top", maxLines: 3 },
                                displayExactValues: true,
                                hAxis: {
                                    format: "#%",
                                    baseline: 0,
                                },
                                displayAnnotations: true,
                                colors: [colorAT, colorPA, colorON],
                            },
                            formatters: {},
                        };

                        scope.attributions = {
                            type: "BarChart",
                            displayed: false,
                            data: {
                                cols: [
                                    {
                                        id: "month",
                                        label: "Month",
                                        type: "string",
                                        p: {},
                                    },
                                    {
                                        id: "laptop-id",
                                        label: "Attribution",
                                        type: "number",
                                        p: {},
                                    },
                                ],
                                rows: [
                                    {
                                        c: [
                                            {
                                                v: "HQPV",
                                            },
                                            {
                                                v: Number(
                                                    data
                                                        .caracteristiqueSociologique
                                                        .pourcentagePremierQuartileHorsQPV
                                                        .AT
                                                ),
                                                f: "",
                                            },
                                        ],
                                    },
                                    {
                                        c: [
                                            {
                                                v: "QPV",
                                            },
                                            {
                                                v: Number(
                                                    data
                                                        .caracteristiqueSociologique
                                                        .pourcentagePremierQuartileQPV
                                                        .AT
                                                ),
                                                f: "",
                                            },
                                        ],
                                    },
                                ],
                            },
                            options: {
                                title: "Attributions au 1er quartile",
                                isStacked: "false",
                                fill: 20,
                                legend: { position: "none" },
                                displayExactValues: true,
                                hAxis: {
                                    format: "#%",
                                    baseline: 0,
                                },
                                colors: [colorAT],
                            },
                            formatters: {},
                        };
                    }
                },
            };

            return directiveDefinitionObject;
        },
    ])
    .directive("patrimoineHlmTable", function factory() {
        var directiveDefinitionObject = {
            templateUrl: "js/directives/patrimoineHlmTableDirective.html",
            scope: {
                dataTerritoire: "=data",
                year: "=year",
                bailleur: "=bailleur"
            },
        };
        return directiveDefinitionObject;
    })
    .directive("caracteristiqueBailleur", function factory() {
        var directiveDefinitionObject = {
            templateUrl: "js/directives/caracteristiqueBailleur.html",
            scope: {
                dataTerritoire: "=data",
                color: "=",
            },
            link: function postLink(scope) {
                function componentToHex(c) {
                    var hex = c.toString(16);
                    return hex.length == 1 ? "0" + hex : hex;
                }

                function rgbToHex(r, g, b) {
                    return (
                        "#" +
                        componentToHex(r) +
                        componentToHex(g) +
                        componentToHex(b)
                    );
                }

                let colorDE,
                    colorAT,
                    colorPA,
                    colorON,
                    color1,
                    color2,
                    color3,
                    color4,
                    color5,
                    color6;

                switch (scope.color) {
                    case "blue":
                        colorDE = rgbToHex(217, 225, 240);
                        colorAT = rgbToHex(189, 215, 238);
                        colorPA = rgbToHex(155, 194, 230);
                        colorON = rgbToHex(73, 118, 199);

                        color1 = rgbToHex(45, 64, 199);
                        color2 = rgbToHex(73, 118, 199);
                        color3 = rgbToHex(155, 194, 230);
                        color4 = rgbToHex(217, 225, 240);
                        color5 = rgbToHex(177, 202, 225);
                        color6 = rgbToHex(189, 215, 238);
                        break;
                    case "green":
                        colorDE = rgbToHex(198, 224, 180);
                        colorAT = rgbToHex(169, 208, 142);
                        colorPA = rgbToHex(112, 173, 71);
                        colorON = rgbToHex(84, 130, 53);

                        color1 = rgbToHex(55, 86, 35);
                        color2 = rgbToHex(84, 130, 53);
                        color3 = rgbToHex(112, 173, 71);
                        color4 = rgbToHex(169, 208, 142);
                        color5 = rgbToHex(198, 224, 180);
                        color6 = rgbToHex(226, 239, 218);
                        break;
                }

                scope.$on("redrawGraph", function (event, color, data, other) {
                    if (color == scope.color) redraw(data);
                });

                function redraw(opt: any) {
                    scope.pdm = {
                        type: "ScatterChart",
                        data: {
                            cols: [
                                {
                                    id: "stock",
                                    label: "Stock",
                                    type: "number",
                                    p: {},
                                },
                                {
                                    id: "neuf",
                                    label: "Neuf",
                                    type: "number",
                                    p: {},
                                },
                            ],
                            rows: [
                                {
                                    c: [
                                        {
                                            v: Number(
                                                opt.caracteristiqueBailleur
                                                    .nombre.PDMGraph
                                            ),
                                        },
                                        {
                                            v: Number(
                                                opt.caracteristiqueBailleur
                                                    .offreNouvelleMoyenneAn
                                                    .PDMGraph
                                            ),
                                        },
                                    ],
                                },
                            ],
                        },
                        options: {
                            title:
                                "Part de marché de votre OLS sur le territoire",
                            hAxis: {
                                title: "Stock",
                                minValue: 0,
                                maxValue: 0.5,
                                format: "#%",
                                gridlines: { count: 5 },
                                viewWindowMode: "maximized",
                            },
                            vAxis: {
                                title: "Neuf",
                                minValue: 0,
                                maxValue: 0.5,
                                format: "#%",
                                gridlines: { count: 5 },
                                viewWindowMode: "maximized",
                            },
                            legend: { position: "none" },
                            colors: [colorPA],
                        },
                    };
                }
            },
        };
        return directiveDefinitionObject;
    })
    .filter("thousanSeparator", function () {
        return function (x) {
            if (!isNaN(parseFloat(x)) && isFinite(x))
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            else return x;
        };
    });



// WEBPACK FOOTER //
// ./resources/assets/js/directives/componentDirective.ts